import { useEffect, useState } from "react";
import Lenis from "lenis";
import "@/App.css";
import { Nav } from "./components/site/Nav";
import { Hero } from "./components/site/Hero";
import { Marquee } from "./components/site/Marquee";
import { About } from "./components/site/About";
import { Services } from "./components/site/Services";
import { Method } from "./components/site/Method";
import { Results } from "./components/site/Results";
import { Booking } from "./components/site/Booking";
import { Faq } from "./components/site/Faq";
import { Footer, FloatingWhatsApp } from "./components/site/Footer";

function App() {
  const [mode, setMode] = useState("");

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.2, smoothWheel: true });
    window.__lenis = lenis;
    let id;
    const raf = (t) => { lenis.raf(t); id = requestAnimationFrame(raf); };
    id = requestAnimationFrame(raf);
    return () => { cancelAnimationFrame(id); lenis.destroy(); window.__lenis = null; };
  }, []);

  return (
    <div className="grain relative" data-testid="app-root">
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <About />
        <Services onPick={setMode} />
        <Method />
        <Results />
        <Booking mode={mode} setMode={setMode} />
        <Faq />
      </main>
      <Footer />
      <FloatingWhatsApp />
    </div>
  );
}

export default App;
